module.exports = __webpack_public_path__ + "img/pocket.2bc1a71a.svg";